import "../../../../styles/css/report.css"
import React, { forwardRef } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useParams } from "react-router-dom";
import ReportV from "../ReportV";
import ReportM from "../ReportM";
import AccessDenied from "../../../admin/pages/AuthPage/AccessDenied";


const Report = forwardRef((props, ref) => {
    const {id, password} = useParams();

    // URL 쿼리 파라미터에서 mode 확인
    const searchParams = new URLSearchParams(window.location.search);
    const isAvatarMode = searchParams.get('mode') === 'avatar';

    console.log('🎭 Report Component - Avatar Mode:', isAvatarMode);

    const { data, isError } = useQuery({
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        queryKey: ['report'],
        queryFn: () => axios("/report/" + id, {
            method: "GET"
        }).then(result => {
            console.log(result.data.data);
            return result.data.data;
        }).catch(e => {
            console.log(e);
        })
    })


    if (password != process.env.REACT_APP_REPORT_PW) {
        return <AccessDenied />
    }

    if (isError) {
        return <>오류가 발생했습니다.</>
    }

    return (
        data &&
        <>
        {
        data.version == "V" &&
        <ReportV data={data} avatarMode={isAvatarMode}/>
        }
        {
        data.version == "M" &&
        <ReportM data={data} avatarMode={isAvatarMode}/>
        }
        </>
    );
});

export default Report;
